import { render, staticRenderFns } from "./AzWiki.vue?vue&type=template&id=b6933044&"
import script from "./AzWiki.vue?vue&type=script&lang=js&"
export * from "./AzWiki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports